"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _color = _interopRequireDefault(require("color"));

var _ScaleIn = _interopRequireDefault(require("./effect/animation/ScaleIn"));

var _styling = require("../toolkit/styling");

var _illustrations = require("../toolkit/illustrations");

var _providers = require("../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Tip = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Tip, _Component);

  var _super = _createSuper(Tip);

  function Tip() {
    var _this;

    (0, _classCallCheck2["default"])(this, Tip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(Tip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          imageUrl = _this$props.imageUrl,
          childrenProp = _this$props.children,
          className = _this$props.className,
          style = _this$props.style;

      var children = _react["default"].Children.toArray(childrenProp).filter(function (e) {
        return /*#__PURE__*/_react["default"].isValidElement(e) || typeof e == "string";
      });

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className, style)
      }, imageUrl && /*#__PURE__*/_react["default"].createElement(_ScaleIn["default"], {
        className: (0, _styling.css)(this.styles.iconWrapper)
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: imageUrl,
        className: (0, _styling.css)(this.styles.icon),
        draggable: "false"
      })), children);
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$props2 = this.props,
          color = _this$props2.color,
          padding = _this$props2.padding,
          iconVerticalAlignment = _this$props2.iconVerticalAlignment;
      var _this$context$theming = this.context.theming.theme,
          borderPrimaryDark = _this$context$theming.borderPrimaryDark,
          surfaceLightest = _this$context$theming.surfaceLightest;
      var borderColor = new _color["default"](borderPrimaryDark).alpha(0.5);
      return _aphrodite.StyleSheet.create({
        root: {
          borderRadius: 4,
          border: "solid 1px ".concat(borderColor),
          overflow: "hidden",
          alignItems: "center",
          borderLeft: "4px solid ".concat(color),
          backgroundColor: surfaceLightest,
          display: "flex",
          flexDirection: "row",
          padding: padding || "20px 14px"
        },
        iconWrapper: {
          marginRight: 16,
          flexShrink: 0,
          alignSelf: iconVerticalAlignment == "top" ? "flex-start" : "center"
        },
        icon: {
          width: 28,
          height: 28,
          alignSelf: "flex-start"
        }
      });
    }
  }]);
  return Tip;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  color: {
    required: true,
    type: "string",
    description: "Color of the left outline of the Tip"
  },
  imageUrl: {
    required: true,
    type: "string",
    description: "Url of image to display"
  },
  padding: {
    required: false,
    type: "string",
    description: "Amount of padding to apply"
  },
  iconVerticalAlignment: {
    required: false,
    defaultValue: "center",
    type: "\"top\" | \"center\"",
    description: "Whether to center the icon or top align it"
  }
}, _class3.demoProps = {
  color: _providers.DefaultThemingContext.theme.corePrimary,
  imageUrl: _illustrations.lightBulb
}, _class3.demoRender = "\n<Tip color={DefaultThemingContext.theme.corePrimary} imageUrl=\"".concat(_illustrations.lightBulb, "\">\n  <div style={{\n    alignItems: \"flex-start\",\n    color: textBlack,\n    display: \"flex\",\n    flexDirection: \"column\",\n    fontSize: 14\n  }}>\n    <div style={{ fontWeight: fonts.weightBold}}>This is a tip.</div>\n    <div style={{ fontWeight: fonts.weightMedium }}>\n      If a refund occurs because the item doesn't match the product\n      listing, the merchant is responsible for 100% of the cost of the\n      refund.\n    </div>\n  </div>\n</Tip>\n"), _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = Tip;
exports["default"] = _default;